module.exports = __webpack_public_path__ + "static/media/MATSON.10914a5e.svg";